(function ($) {
    $(window).on('load', function () {
        $('.site-cart-link--cart a').removeAttr('style');
    });
    $(function () {
        var $mobileTrigger = $('.js-menu-trigger'),
            $closeMobile = $('.js-menu-close'),
            $hamburger = $('.js-hamburger'),
            $menu = $('.js-main-navigation'),
            $menuContainer = $('.js-site-navigation'),
            $hasSubMenu = $menu.find('.menu-item-has-children');

        //Open the menu on mobile
        $mobileTrigger.on('click', function (e) {
            $hamburger.addClass('is-active');
            $menuContainer.addClass('open-menu');
        });

        $mobileTrigger.on("keypress", function (e) {
            /* ENTER PRESSED*/
            if (e.keyCode === 13) {
                $hamburger.addClass('is-active');
                $menuContainer.addClass('open-menu');
                $menu.find("#primary-menu > li:first-child > a").focus();
            }
        });

        $closeMobile.on('click', function (e) {
            $hamburger.removeClass('is-active');
            $menuContainer.removeClass('open-menu');
        });

        $closeMobile.on("keypress", function (e) {
            /* ENTER PRESSED*/
            if (e.keyCode === 13) {
                $hamburger.removeClass('is-active');
                $menuContainer.removeClass('open-menu');
                $('.site-header__cart a').focus();
            }
        });

        //Open sub menu on mobile and tablet
        $hasSubMenu.on('click', function () {
            $(this).toggleClass('active');
        });

        /**
         * AA Mobile Navigation
         */
        var menuItemsWithSubmenu = document.querySelectorAll('#primary-menu > li.menu-item-has-children');
        Array.prototype.forEach.call(menuItemsWithSubmenu, function (menuItem) {
            menuItem.querySelector('a').addEventListener("focus", function (event) {
                this.parentNode.classList.add("open");
                this.nextElementSibling.classList.add("focused");
                this.setAttribute('aria-expanded', "true");
                event.preventDefault();
                return false;
            });
        });

        var subMenus = document.querySelectorAll('#primary-menu > li.menu-item-has-children > .sub-menu');
        Array.prototype.forEach.call(subMenus, function (firstlink) {
            var allLinksInSubMenus = firstlink.querySelectorAll('a');
            Array.prototype.forEach.call(allLinksInSubMenus, function (link, key, arr) {
                document.addEventListener('keydown', function (event) {
                    if (event.keyCode === 27) {
                        hideSubMenu(firstlink);
                    }
                });
                link.addEventListener("blur", function (event) {
                    if (Object.is(arr.length - 1, key)) {
                        hideSubMenu(firstlink);
                    }
                });
            });

            document.addEventListener('click', function (event) {
                var isClickInside = firstlink.contains(event.target);
                if (!isClickInside) {
                    firstlink.parentNode.classList.remove("open");
                    firstlink.classList.remove('focused');
                    firstlink.previousElementSibling.setAttribute('aria-expanded', 'false');
                }
            });
        });

        function hideSubMenu(link) {
            link.parentNode.classList.remove("open");
            link.classList.remove('focused');
            link.previousElementSibling.setAttribute('aria-expanded', 'false');
        }

    });

})(jQuery);


// Page load 
window.addEventListener("load", function () {
  setTimeout(function () {
    document.body.classList.add("loaded");
  }, 500);
});
